import React from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { StoreType } from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
} from "client/components"

const Details = () => {
    const item = useSelector((state: StoreType) => state.ccCompliance.itemDetails)
    const lang = useSelector((state: StoreType) => state.system.lang)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.id}</Label>
                        <Input type="text" value={item.publicId} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.compliantItem}</Label>
                        <Textarea value={item.compliantItem} readOnly />
                    </FormGroup>
                    {
                        item.interpretation.length > 0 && (
                            <FormGroup>
                                <Label>{lang.interpretation}</Label>
                                <Textarea value={item.interpretation} readOnly />
                            </FormGroup>
                        )
                    }
                </Col>
            </Row>
        </PageForm>
    )
}
export default Details
